export enum QueryParams {
  SEVERITY = 'severity',
  ISSUE_NUMBER = 'issueNumber',
}
